// extracted by mini-css-extract-plugin
export default {"grecaptchaLegalNotice":"ContactInfoModal__grecaptchaLegalNotice__WZwgS"};